<template>
  <div class="flex items-center justify-between rounded-sm border border-success bg-success-subtle p-3" data-testid="page-uploaded-file">
    <div class="flex flex-col">
      <h3 class="mb-1 txt-body-m-bold"><CircleCheck class="mr-1 inline" :size="16" />{{ name }}</h3>
      <p class="txt-body-s text-subtle">Uploaded {{ formatDate(createdAt, true) }}</p>
    </div>
    <Trash2 v-if="allowRemove" class="cursor-pointer" :size="16" @click="remove" />
    <button v-else-if="allowReplace" class="btn-outline-neutral-xs" type="button" @click="openReplacePicker">
      {{ t('FestivalShop.products.documents.reupload') }}
    </button>
    <input ref="fileInput" class="hidden" type="file" accept="image/png,image/svg,.pdf" @change="handleReplace" />
  </div>
</template>
<script lang="ts" setup>
import { CircleCheck, Trash2 } from '@ramp106/omrjs-core-ui/icons'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { formatDate } from '@/components/FestivalShop/helpers'

const { t } = useI18n()

const props = defineProps<{
  id: string
  name: string
  url: string
  createdAt: string
  allowRemove?: boolean
  allowReplace?: boolean
}>()

const emit = defineEmits<{
  (e: 'remove', fileId: string): void
  (e: 'replace', payload: { file: File; fileId: string }): void
}>()

const fileInput = ref<HTMLInputElement | null>(null)

const remove = () => emit('remove', props.id)

const openReplacePicker = () => {
  fileInput.value?.click()
}

const handleReplace = (event: Event) => {
  const target = event.target as HTMLInputElement
  const file = target.files?.[0]
  if (!file) return
  emit('replace', { file, fileId: props.id })
  target.value = ''
}
</script>
